import { Link } from 'react-router-dom'
import type { FunnelStage } from './types'

const STATUS_TO_URL: Record<string, string> = {
  NEW: '/requests?status=NEW',
  IN_PROGRESS: '/requests?status=IN_PROGRESS',
  QUOTATION_READY: '/requests?status=QUOTATION_READY',
  QUOTE_SENT: '/requests?status=QUOTE_SENT',
  CLOSED_WON: '/requests?status=CLOSED_WON',
}

const COLORS: Record<string, string> = {
  NEW: '#93c5fd',
  IN_PROGRESS: '#1e3a8a',
  QUOTATION_READY: '#10b981',
  QUOTE_SENT: '#047857',
  CLOSED_WON: '#8b5cf6',
}

export function FunnelChart({ funnel }: { funnel: FunnelStage[] }) {
  const first = funnel[0]?.count ?? 0
  const last = funnel[funnel.length - 1]?.count ?? 0
  const conversion = first === 0 ? 0 : Math.round((last / first) * 1000) / 10

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Воронка заявок</div>

      <div className="flex-1 space-y-2.5">
        {funnel.map((stage) => {
          const url = STATUS_TO_URL[stage.status]
          const bg = COLORS[stage.status] ?? '#94a3b8'
          const width = Math.max(3, stage.percent)
          const content = (
            <div className="group">
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="text-gray-700">
                  {stage.label}
                  {stage.status === 'CLOSED_WON' && (
                    <span className="ml-1 text-[10px] text-gray-400">(после отправки КП)</span>
                  )}
                </span>
                <span className="text-gray-500 tabular-nums">
                  всего {stage.count} · {stage.percent}%
                  <span className="ml-2 text-gray-400">· активных {stage.activeCount}</span>
                </span>
              </div>
              <div className="h-2.5 bg-gray-100 rounded overflow-hidden">
                <div
                  className="h-full rounded transition-all"
                  style={{ width: `${width}%`, backgroundColor: bg }}
                />
              </div>
            </div>
          )
          return url ? (
            <Link key={stage.status} to={url} className="block hover:opacity-90 transition-opacity">
              {content}
            </Link>
          ) : (
            <div key={stage.status}>{content}</div>
          )
        })}
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100 text-xs text-gray-500">
        Конверсия: <span className="font-semibold text-gray-900">{conversion}%</span>
      </div>
    </div>
  )
}
